<script setup lang="ts">
import { Head, router } from '@inertiajs/vue3'
import { CheckCircle } from 'lucide-vue-next'

import { Button } from '@/components/ui/button'
import LandingLayout from '@/layouts/LandingLayout.vue'
import { applyPagePath } from '@/routes'

defineProps<{ portal_login_url: string }>()

function applyForAnother() {
  localStorage.removeItem('tlc_customer_id')
  localStorage.removeItem('tlc_application_id')
  router.visit(applyPagePath())
}
</script>

<template>
  <Head title="Application Submitted" />
  <LandingLayout>
    <div class="flex flex-col items-center gap-6 py-12 text-center">
      <CheckCircle class="size-16 text-green-500" />
      <div>
        <h1 class="text-2xl font-bold">Application Submitted!</h1>
        <p class="text-muted-foreground mt-2">
          Thank you for applying. A TLC representative will be in touch with you shortly to discuss your loan.
        </p>
      </div>
      <div class="flex flex-col items-center gap-3 sm:flex-row">
        <Button :as="'a'" :href="portal_login_url">Track your application</Button>
        <Button variant="outline" @click="applyForAnother"> Apply for a different person </Button>
      </div>
    </div>
  </LandingLayout>
</template>
